<template>
  <div
    class="fixed inset-0 bg-[rgba(0,0,0,0.4)] z-[1111] flex justify-end overflow-y-auto"
    id="popup-content"
    @click.self="closeModal"
  >
    <div
      class="relative w-full lg:w-[80%] max-h-screen bg-[#f8f8f8] px-[12px] py-[30px] md:p-[40px] overflow-auto"
    >
      <div class="shadow-none bg-transparent">
        <div class="flex items-start justify-between">
          <p class="text-[#353535] text-[20px] leading-[20px] font-semibold">
            Stock Details
          </p>
          <button
            class="text-2xl text-[#353535] outline-none focus:outline-none"
            type="button"
            @click="closeModal"
          >
            <span class="mdi mdi-close"></span>
          </button>
        </div>
        <div class="bg-white p-1 rounded-[4px] mt-[16px] flex flex-col">
          <div
            class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2 w-full"
          >
            <h2
              class="font-normal text-[16px] text-[#96a0b5] md:max-w-[200px] w-full"
            >
              Customer Name
            </h2>
            <span
              class="font-medium w-full text-[16px] text-[#353535] leading-[19.36px]"
              >{{ reconciledDetails.name }}</span
            >
          </div>
          <div
            class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2 w-full"
          >
            <h2
              class="font-normal text-[16px] text-[#96a0b5] md:max-w-[200px] w-full"
            >
              Code
            </h2>
            <span
              class="font-medium w-full text-[16px] text-[#353535] leading-[19.36px]"
              >{{ reconciledDetails.code }}</span
            >
          </div>
          <div
            class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2 w-full"
          >
            <h2
              class="font-normal text-[16px] text-[#96a0b5] md:max-w-[200px] w-full"
            >
              Product
            </h2>
            <span
              class="font-medium w-full text-[16px] text-[#353535] leading-[19.36px]"
              >{{ reconciledDetails.product }}</span
            >
          </div>
          <div
            class="flex flex-col md:flex-row items-start gap-2 md:items-center md:gap-4 mt-2 w-full"
          >
            <h2
              class="font-normal text-[16px] text-[#96a0b5] md:max-w-[200px] w-full"
            >
              Quantity Reconciled
            </h2>
            <span
              class="font-medium w-full text-[16px] text-[#353535] leading-[19.36px]"
              >{{ reconciledDetails.quantity }}</span
            >
          </div>
        </div>
        <div
          class="bg-white px-[15px] py-[24px] sm:px-[24px] sm:py-[32px] mt-[16px] rounded-[4px]"
        >
          <h2
            class="text-[16px] font-bold leading-[20px] text-[#353535] mb-[16px]"
          >
            Order Details
          </h2>
          <div class="table-responsive" id="printing">
            <table class="table text-nowrap">
              <thead class="bg-[#ECF9FF]">
                <tr>
                  <th
                    class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                  >
                    Inventory Id
                  </th>
                  <th
                    class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                  >
                    Location
                  </th>
                  <th
                    class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                  >
                    Product Batch Id
                  </th>
                  <th
                    class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                  >
                    Expiry Date
                  </th>
                  <th
                    class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                  >
                    Cost Price
                  </th>
                  <th
                    class="text-[12px] leading-[18px] text-[#000000] font-semibold"
                  >
                    Qty
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(rd, index) in reconciledDetails.list" :key="index">
                  <td
                    class="text-[14px] font-medium leading-[16.94px] text-[#353535]"
                  >
                    {{ rd.inventoryId }}
                  </td>
                  <td
                    class="text-[14px] font-medium leading-[16.94px] text-[#353535]"
                  >
                    {{ rd.location }}
                  </td>
                  <td
                    class="text-[14px] font-medium leading-[16.94px] text-[#353535]"
                  >
                    {{ rd.batchId ? rd.batchId : "***" }}
                  </td>
                  <td
                    class="text-[14px] font-medium leading-[16.94px] text-[#353535]"
                  >
                    {{ rd.expiryDate ? formatDate(rd.expiryDate) : "" }}
                  </td>
                  <td
                    class="text-[14px] font-medium leading-[16.94px] text-[#353535]"
                  >
                    &#8358;{{ rd.costPrice }}
                  </td>
                  <td
                    class="text-[14px] font-medium leading-[16.94px] text-[#353535]"
                  >
                    {{ rd.quantityReconciled }}
                  </td>
                </tr>
                <tr v-if="!reconciledDetails.list">
                  <td colspan="12">
                    <div class="text-center">No items in order</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { helper } from "@/helper";
export default {
  props: ["closeModal", "reconciledDetails"],
  methods: {
    formatDate(date) {
      return moment(date).format("ll");
    },

    formatMoney(val) {
      return helper.formatMoney(val);
    },

    formatNumber(val) {
      return helper.formatNumber(val);
    },
  },
};
</script>

<style></style>
